import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { InformationOutline } from '@opengov/react-capital-assets';
import React from 'react';
import locale from './customReports-locale.json';
import { styles } from './FontAccessibilityWarning.styles';

export function FontAccessibilityWarning() {
  return (
    <Box sx={styles.container}>
      <SvgIcon component={InformationOutline} inheritViewBox sx={styles.informationIcon} />
      <Typography variant="body1">{locale.fontAccessibilityWarning}</Typography>
    </Box>
  );
}
